'use client';

import { Eye, EyeClosed } from 'lucide-react';
import { useState } from 'react';
import { FormInput, type FormInputProps } from './FormInput';

export function FormPasswordInput(props: FormInputProps) {
  // want to add an eye show hide pw icon
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      icon={
        showPassword ? (
          <Eye
            className="cursor-pointer rounded-sm border border-white bg-gray-100 p-0.5 transition-colors hover:border-gray-200"
            onClick={(e) => {
              setShowPassword(false);
            }}
          />
        ) : (
          <EyeClosed
            className="cursor-pointer rounded-sm border border-white p-0.5 transition-colors hover:border-gray-200 hover:bg-gray-100"
            onClick={(e) => {
              setShowPassword(true);
            }}
          />
        )
      }
    />
  );
}
